import {
    buildRoutingPrefix,
    onBoardingRoutingPrefix,
    plgCRMRoutingPrefix,
    signupBuilderRoutingPrefix,
    workflowRoutingPrefix,
    driveRoutingPrefix,
    invitationSimulationPrefix
} from "./mfe";

export enum RootURLS {
    HOME_URL = "/",
    BUILD_URL = `${buildRoutingPrefix}`,

    ANALYZE_URL = `${plgCRMRoutingPrefix}`,

    DRIVE_URL = `${driveRoutingPrefix}`,
    ON_BOARDING_URL = `${onBoardingRoutingPrefix}`,
    INVIATION_SIMULATION_BOARDING_URL = `${invitationSimulationPrefix}`,
    WORKFLOW_URL = `${workflowRoutingPrefix}`,
    SIGNUP_BUILDER_URL = `${signupBuilderRoutingPrefix}`
}

export enum BuildURLs {
    GET_STARTED_URL = `/${RootURLS.BUILD_URL}/setup/quick-start/`,
    SETTINGS = `${RootURLS.HOME_URL}/settings`
}

export enum AuthenticationURLs {
    AUTH_SIGN_UP_URL = `auth/sign-up`,
    CUSTOMER_ANALYTICS_AUTH_SIGN_UP_URL = `auth/customer-analytics/sign-up`,
    AUTH_SIGN_UP_VERIFICATION_URL = `auth/verify`
}

export enum AnalyzeUrls {
    PRICING = `${RootURLS.HOME_URL}customer-analytics/pricing`
}
